var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"prz-blk-content-rating"},[_c('Rating',{attrs:{"value":_vm.starRating.rating,"scale":10}}),_c('span',[_vm._v(" "+_vm._s(_vm.ratingLabel)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }